import { motion } from "framer-motion";
import { Mail, ArrowRight, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Reveal } from "@/components/Reveal";

export default function ContactPage() {
  return (
    <main className="min-h-screen bg-obsidian text-pearl" data-testid="contact-page">
      <header className="border-b border-black/10 bg-white/85 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
          <Logo compact />
          <a
            href="/"
            data-testid="contact-back-link"
            className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-champagne transition-colors"
          >
            <ArrowLeft size={15} /> Back to site
          </a>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-36">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] uppercase text-champagne mb-6">Contact</p>
          <h1 className="font-display font-light tracking-tight text-5xl sm:text-6xl leading-[1.05]">
            Talk to a <span className="italic text-champagne">human.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-zinc-500 leading-relaxed max-w-xl">
            Questions about the Engine, pricing, or fit? Email the founder directly. No ticket
            system, no queue. We reply fast, and usually within minutes.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <a
            href="mailto:jumi@gonorthnoble.com"
            data-testid="contact-email-card"
            className="mt-12 flex items-center gap-6 border border-champagne/40 bg-gradient-to-b from-champagne/10 to-white p-8 md:p-10 shadow-[0_20px_60px_rgba(61,165,221,0.12)] group transition-[transform,box-shadow] duration-500 hover:-translate-y-1"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-champagne text-white shadow-[0_10px_30px_rgba(61,165,221,0.4)]">
              <Mail size={22} strokeWidth={1.8} />
            </span>
            <span>
              <span className="block font-mono text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                Email the founder
              </span>
              <span className="mt-1 block font-display text-2xl md:text-3xl text-pearl group-hover:text-champagne transition-colors">
                jumi@gonorthnoble.com
              </span>
            </span>
          </a>
        </Reveal>

        <Reveal delay={0.25}>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mt-12 border border-black/10 bg-coal p-8 shadow-sm"
          >
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-champagne mb-3">Fastest option</p>
            <p className="text-zinc-500 leading-relaxed">
              Want the numbers conversation instead? Book a Revenue Leak Audit and you are on the
              founder's calendar directly.
            </p>
            <a
              href="/#book"
              data-testid="contact-book-cta"
              className="btn-shine mt-6 inline-flex items-center gap-3 rounded-full bg-champagne px-7 py-3.5 text-sm font-medium tracking-wide text-white hover:bg-champagne-soft transition-colors duration-300 group"
            >
              Book My Revenue Leak Audit
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1.5" />
            </a>
          </motion.div>
        </Reveal>
      </div>
    </main>
  );
}
